export class AuditResponseModel {
    branchId: string;
    branchName: string;
    comment: string;
    createdAt: string;
    creator: string;
    creatorId: string;
    creatorName: string;
    eventTime: string;
    id: string;
    orderId: string;
    partnerId: string;
    partnerName: string;
    updatedAt: string;
    userRoleName: string;
}
export class customerAuditResponseModel {
    comment: string;
    eventTime: string;
    creatorName: string;
}
export class customerBankAccountModel {
    bankAccountVerificationStatus: string;
    bankName: string;
    branch: string;
    consumerId: string;
    default: Boolean;
    id: string;
    ifscCode: string;
    number: string;
    status: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/audit/AuditResponseModel.ts